import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../../base";

import { StatusActions } from "./hook";

function FormConsentInstructionsInputPreview({ ...props }) {
  return <BasePreview {...props} customActions={<StatusActions />}>
    <input type="checkbox" />
  </BasePreview>
}

export default define('form-consent-instructions-input', FormConsentInstructionsInputPreview, Fragment)
  .shared(prop.share('FormConsentInstructionsInput', 'form-consent-instructions-input'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultUtilities([
    '[[data-status=checked]_&]',
    '[[data-status=error]_&]',
  ])
  .build()
